<template>
  <div class="ip">
    <div class="page-title">Ip Shopping Mall</div>
    <!-- 轮播 -->
    <div class="swiper-box">
      <el-skeleton :loading="!list.length" animated>
        <template #template>
          <el-skeleton-item
            variant="image"
            style="width: 100%; height: 6.6rem"
          />
          <el-skeleton-item
            variant="image"
            style="width: 100%; height: 0.4rem; margin: 0.42rem 0"
          />
        </template>
        <template #default>
          <swiper
            :modules="modules"
            :slides-per-view="1"
            :space-between="0"
            :navigation="navigation"
            :pagination="{ clickable: true, el: '.custom-pagination' }"
          >
            <swiper-slide v-for="item in list" :key="item.id">
              <div class="slider_item">
                <img
                  @click="openDetail(item.id)"
                  :src="item.bannerImage || item.coverImage"
                  style="width: 100%"
                />
              </div>
            </swiper-slide>
          </swiper>
          <div class="custom-pagination"></div>
          <!-- 自定义分页器容器 -->
        </template>
      </el-skeleton>
    </div>
    <!-- 搜索（移到顶部轮播下方） -->
    <div class="down">
      <div class="search_bar">
        <div class="input_dom">
          <el-input size="large" type="text" class="ipt" v-model="keyword" />
          <img
            class="search_icon"
            src="@/assets/images/search.png"
            alt=""
            @click="handleSearch"
          />
        </div>
      </div>
    </div>
    <div class="mid_title">Virtual Characters</div>
    <!-- 轮播 -->
    <div class="swiper-box-1">
      <el-skeleton :loading="!swiperList.length" animated>
        <template #template>
          <div style="display: flex; justify-content: space-around">
            <div v-for="(item, index) in 5" :key="index">
              <div class="slider_item">
                <el-skeleton-item
                  variant="circle"
                  style="width: 2.08rem; height: 2.08rem"
                />
              </div>
            </div>
          </div>
          <el-skeleton-item variant="image" style="margin: 0.42rem 0" />
        </template>
        <template #default>
          <swiper
            :modules="modules"
            :slides-per-view="5"
            :space-between="0"
            :navigation="navigation"
            :pagination="{ clickable: true, el: '.custom-pagination1' }"
          >
            <swiper-slide v-for="(item, index) in swiperList" :key="item.id">
              <div class="slider_item">
                <img
                  :class="highlightedIndex === index ? 'light_img' : 'img'"
                  :src="item.imageUrl || item.coverImage || '/default-ip.jpg'"
                  @click="() => handleMouseOverImg(item.id, index)"
                />
                <div>{{ item.name }}</div>
              </div>
            </swiper-slide>
            <div class="custom-pagination1">
              <div
                class="swiper-pagination-bullet1"
                v-for="(item, index) in numSlides"
                :key="index"
                :style="paginationBulletWidth"
              ></div>
            </div>
          </swiper>
        </template>
      </el-skeleton>
      <!-- 自定义分页器容器 -->
    </div>
    <!-- 商品列表 -->
    <el-skeleton :loading="loading" animated>
      <template #template>
        <div class="shop_list">
          <div class="item" v-for="i in 9" :key="i">
            <el-skeleton-item
              variant="image"
              style="width: 3.8rem; height: 4.69rem"
            />
          </div>
        </div>
      </template>
      <template #default>
        <div v-if="goodList && goodList.length > 0" class="shop_list">
          <div class="item" v-for="i in goodList" :key="i.id">
            <img
              :src="i.coverImage || '/default-product.jpg'"
              alt=""
              @click="openDetail(i.id)"
              class="item_item"
            />
          </div>
        </div>
        <el-empty v-else description="暂无商品上架" />
      </template>
    </el-skeleton>
  </div>
</template>
<script setup>
import { Swiper, SwiperSlide } from "swiper/vue";
import { ref, computed, reactive, onMounted, watch } from "vue";
import { Navigation, Pagination } from "swiper/modules";
import { useRouter } from "vue-router";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination"; // 导入 Pagination 样式
import {
  getTopImageData,
  getSwipperData,
  getListDetailData,
} from "@/api/shopping";
const router = useRouter();
const highlightedIndex = ref(0);
const keyword = ref();
const numSlides = ref(0);
const navigation = ref({
  nextEl: ".swiper-button-next",
  prevEl: ".swiper-button-prev",
});

const modules = [Navigation, Pagination];
const list = reactive([]);
const swiperList = reactive([]);
const goodList = ref([]);
const loading = ref(false);
const currentIpId = ref();

const handleMouseOverImg = (ipId, index) => {
  highlightedIndex.value = index;
  currentIpId.value = ipId;
};

const paginationBulletWidth = computed(() => `${100 / (numSlides.value - 3)}%`);

const openDetail = (id) => {
  router.push(`/shopping/detail/${id}`);
};

const fetchTopData = () => {
  // 获取顶部热门图片信息
  getTopImageData().then((res) => {
    if (res && res.code === 200) {
      // 修复：res.data现在是对象，需要访问records数组
      const dataArray = res.data?.records || [];
      list.splice(0, list.length, ...dataArray);
    }
  });

  // 获取ip轮播图信息（IP分类列表）
  getSwipperData().then((res) => {
    // console.log(res);
    if (res && res.code === 200) {
      // 修复：res.data现在是IP分类列表数组，不是分页对象
      const dataArray = Array.isArray(res.data)
        ? res.data
        : res.data?.records || [];
      swiperList.splice(0, swiperList.length, ...dataArray);
      numSlides.value = dataArray.length;
      currentIpId.value = dataArray.length > 0 ? dataArray[0].id : ""; //默认选中第一个ip分类
    }
  });

  // 获取ip对应商品列表
  // fetchIpGoodsList("");
};

onMounted(() => fetchTopData());
watch(currentIpId, () => {
  fetchIpGoodsList("");
});

const handleSearch = () => {
  // highlightedIndex.value = null;
  // currentIpId.value = null;
  fetchIpGoodsList(keyword.value);
};

const fetchIpGoodsList = (keyword) => {
  getListDetailData({ ipId: currentIpId.value, keyword }).then((res) => {
    if (res && res.code === 200) {
      // 修复：res.data现在是对象，需要访问records数组
      goodList.value = res.data?.records || [];
    }
  });
};
</script>

<style lang="scss" scoped>
.ip {
  text-align: center;
  /* 与首页一致：不铺实底，露出 body 星光层（theme-atmosphere） */
  background-color: transparent;
  min-height: 100vh;
  padding: 86px 240px 0 240px;
  .page-title {
    margin-top: 84px;
    font-weight: bold;
    font-size: 80px;
    color: var(--ux-text-primary);
    line-height: 94px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin-bottom: 80px;
  }
  .top {
    display: flex;
    justify-content: space-between;
    margin-top: 74px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .top_img {
      width: 380px;
      height: 312px;
      position: relative;
      overflow: hidden;
      &:hover {
        cursor: pointer;
      }

      .slide-class {
        transform: translateY(0);
        position: relative;
        transition: all 0.3s ease-in-out;
        &:hover {
          transform: translateY(-312px);
        }
      }
      .slide-img {
        width: 380px;
        height: 312px;
      }
    }
  }
  .swiper-box-1 {
    margin-top: 83px;
    .slider_item {
      text-align: center;
    }
    img {
      margin-bottom: 20px;
      border-radius: 50%;
      width: 208px;
      height: 208px;
      opacity: 0.2;
      &:hover {
        cursor: pointer;
      }
    }
    .light_img {
      border-radius: 50%;
      width: 208px;
      height: 208px;
      opacity: 1;
      margin-bottom: 20px;
    }
    .custom-pagination1 {
      padding: 42px 0;
      text-align: center;

      ::v-deep .swiper-pagination-bullet {
        height: 8px;
        width: v-bind(paginationBulletWidth);
        background: var(--ux-surface-muted);
        opacity: 0.5;
        border-radius: 0;
        margin: 0;
        border-radius: 5px;
      }
      ::v-deep .swiper-pagination-bullet-active {
        background-color: var(--ux-accent, #00d4ff);
      }
    }
  }
  .swiper-box {
    ::v-deep .swiper-wrapper {
      height: 666px !important;
    }
    .swiper-slide {
      position: relative;
      img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        cursor: pointer;
      }
    }
    .custom-pagination {
      padding: 42px 0;
      text-align: center;

      ::v-deep .swiper-pagination-bullet {
        width: 25.998px;
        height: 25.998px;
        display: inline-block;
        background: var(--ux-surface-muted);
        opacity: 0.5;
        border-radius: 50%;
        margin: 0 16.996px;
      }
      ::v-deep .swiper-pagination-bullet-active {
        background-color: var(--ux-accent, #00d4ff);
      }
    }
  }
  .down {
    margin-bottom: 42px;
    .search_bar {
      display: flex;
      align-items: center;
      justify-content: right;
      margin: 54px 0 0 0;
      .search_item {
        width: 158px;
        height: 46px;
        background: var(--ux-glass-bg-subtle);
        border-radius: 10px 10px 10px 10px;
        text-align: center;
        line-height: 46px;
        font-size: 20px;
        margin: 0 39.998px;
        cursor: pointer;
        font-weight: 400;
        font-size: 20.006px;
        color: var(--ux-text-primary);
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
      .input_dom {
        margin-left: 56px;
        display: flex;
        align-items: center;
        .ipt {
          width: 360px;
        }
        .search_icon {
          width: 24px;
          margin-left: 5px;
          cursor: pointer;
        }
      }
    }
  }
  .shop_list {
    margin-top: 60px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr; /* 创建三列 */
    // grid-gap: 123px; /* 设置列之间的间距 */
    width: 100%;
    .item {
      margin-bottom: 84px;
      width: 380px;
      height: 469px;
      margin-right: 140px;
      overflow: hidden;
      &:nth-child(3n) {
        margin-right: 0;
      }
      position: relative;
      img {
        width: 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
  .mark {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5); /* 半透明黑色背景 */
    z-index: 999; /* 确保遮罩在其他内容之上 */
  }
  .mid_title {
    font-size: 32px;
    font-weight: bold;
    margin-top: 40px;
  }
}
</style>
